var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 2.82376C13.576 2.49901 13.3452 2 12.919 2H3.08187C2.65555 2 2.42479 2.4993 2.70104 2.824L6.72698 7.55603C6.80391 7.64646 6.84615 7.76131 6.84615 7.88003V12.0057C6.84615 12.1624 6.91958 12.31 7.04452 12.4045L8.35221 13.3936C8.68157 13.6428 9.15385 13.4078 9.15385 12.9949V7.88692C9.15385 7.76831 9.19602 7.65355 9.27283 7.56316L13.3 2.82376Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/icon-filter.bb466bb9760aac0dbf203622f14677db.svg";
export { ForwardRef as ReactComponent };